import { Form, Input, Space, TableColumnsType, Tooltip } from 'antd';
import { EditIcon, EyeIcon } from 'assets/svg';
import { memo } from 'react';

import { ButtonAction } from 'components';
import TableComponent from 'components/Table/TableComponent';
import Content from 'layouts/Content';
import formatNumber from 'utils/constants/functions';
import { icons } from 'utils/constants/icons';

const { SaveTwoTone, CloseCircleTwoTone } = icons;

interface IProps {
  data: any[];
  loading: boolean;
  selectedIndex?: number;
  onCancel: () => void;
  setSelectedIndex: (data: number) => void;
  onRowChange: (record: any, newValue: any) => void;
}

const TableAverageOrder = memo(
  ({
    data,
    loading,
    selectedIndex,
    setSelectedIndex,
    onCancel,
    onRowChange,
  }: IProps) => {
    const [form] = Form.useForm();

    const columns: TableColumnsType = [
      {
        title: 'STT',
        width: 50,
        render: (_, __, index) => index + 1,
      },
      {
        title: 'Chi nhánh',
        dataIndex: 'branchId',
        width: 150,
        render: (value, _, index) => {
          return index === selectedIndex ? (
            <Form.Item
              className="m-0"
              name="branchId"
              initialValue={value}
              rules={[{ required: true, message: 'Nhập tên chi nhánh' }]}
            >
              <Input defaultValue={value} />
            </Form.Item>
          ) : (
            value
          );
        },
      },
      {
        title: 'Tên chi nhánh',
        dataIndex: 'branchName',
        width: 150,
        render: (value, _, index) => {
          return index === selectedIndex ? (
            <Form.Item
              className="m-0"
              name="branchName"
              initialValue={value}
              rules={[{ required: true, message: 'Nhập tên chi nhánh' }]}
            >
              <Input defaultValue={value} />
            </Form.Item>
          ) : (
            value
          );
        },
      },
      {
        title: 'Trung bình đơn',
        dataIndex: 'averageOrder',
        width: 150,
        render: (value, _, index) => {
          return index === selectedIndex ? (
            <Form.Item
              className="m-0"
              name="averageOrder"
              initialValue={value}
              rules={[{ required: true, message: 'Nhập tên chi nhánh' }]}
            >
              <Input defaultValue={value} />
            </Form.Item>
          ) : (
            formatNumber(value)
          );
        },
      },
      {
        title: 'Tiền tệ',
        dataIndex: 'currency',
        width: 150,
        render: (value: string, _, index) => {
          return index === selectedIndex ? (
            <Form.Item
              className="m-0"
              name="currency"
              initialValue={value}
              rules={[{ required: true, message: 'Nhập tên chi nhánh' }]}
            >
              <Input defaultValue={value.toUpperCase()} />
            </Form.Item>
          ) : (
            value.toUpperCase()
          );
        },
      },
      {
        title: 'Người tạo',
        dataIndex: 'createBy',
        width: 150,
      },
      {
        title: 'Ngày tạo',
        dataIndex: 'createAt',
        width: 180,
      },
      {
        title: 'Người cập nhật',
        dataIndex: 'updateBy',
        width: 150,
      },
      {
        title: 'Ngày cập nhật',
        dataIndex: 'updateAt',
        width: 180,
      },
      {
        title: '',
        fixed: 'right',
        align: 'center',
        width: 150,
        render: (_, record, index) => {
          return selectedIndex === index ? (
            <Space size={'middle'} className="text-lg ">
              <ButtonAction tooltip="Lưu" onClick={() => handleSave(record)}>
                <SaveTwoTone style={{ fontSize: 20 }} />
              </ButtonAction>
              <ButtonAction tooltip="Hủy" onClick={handleCancel}>
                <CloseCircleTwoTone style={{ fontSize: 20 }} />
              </ButtonAction>
            </Space>
          ) : (
            <Space size={'middle'} className="text-lg ">
              <Tooltip placement="top" title={'Xem chi tiết'}>
                <EyeIcon className="cursor-pointer" />
              </Tooltip>
              <Tooltip placement="top" title={'Chỉnh sửa'}>
                <EditIcon
                  className="cursor-pointer"
                  onClick={() => {
                    if (selectedIndex !== undefined) return;

                    const fields = record;
                    form.setFieldsValue(fields);
                    setSelectedIndex(index);
                  }}
                />
              </Tooltip>
            </Space>
          );
        },
      },
    ];

    const checkFormValidate = async () => {
      try {
        await form.validateFields();
        return true;
      } catch (error) {
        return false;
      }
    };

    const handleSave = async (record: any) => {
      if (!(await checkFormValidate())) {
        form.validateFields();
        return;
      }

      const fields = form.getFieldsValue();
      onRowChange(record, fields);
      form.resetFields();
    };

    const handleCancel = () => {
      onCancel();
      form.resetFields();
    };

    return (
      <Content>
        <Form form={form}>
          <TableComponent
            rowKey={(record: any) => record.branchId}
            dataSource={data}
            columns={columns}
            loading={loading}
          />
        </Form>
      </Content>
    );
  },
);

export default TableAverageOrder;
